import { DropdownItemProps } from "semantic-ui-react";

export interface ISpecificExportsQuery {
    type: SpecificExportsType;
    startDate: string;
    endDate: string;
    quarter: number;
    year?: number;
    examinationOrganization?: string;
    administrativeNumberFrom?: string;
    administrativeNumberTo?: string;
    qualificationIdFrom?: string;
    qualificationIdTo?: string;
}

export enum SpecificExportsType {
    MonthlyReport,
    ReportToTheMinistryOfFinance,
    OpenItemsList,
    DownloadApplicationDocuments,
}

export const newSpecificExportsQueryInit: ISpecificExportsQuery = {
    type: SpecificExportsType.MonthlyReport,
    startDate: "",
    endDate: "",
    quarter: 1
};

export const specificExportTypeOptions: DropdownItemProps[] = [
    {
        key: SpecificExportsType.MonthlyReport,
        text: "monthlyReport",
        value: SpecificExportsType.MonthlyReport,
    },
    {
        key: SpecificExportsType.ReportToTheMinistryOfFinance,
        text: "reportToTheMinistryOfFinance",
        value: SpecificExportsType.ReportToTheMinistryOfFinance,
    },
    {
        key: SpecificExportsType.OpenItemsList,
        text: "openItemsList",
        value: SpecificExportsType.OpenItemsList,
    },
    {
        key: SpecificExportsType.DownloadApplicationDocuments,
        text: "downloadApplicationDocuments",
        value: SpecificExportsType.DownloadApplicationDocuments,
    },
];
